/**
 * This file handles the lava lamp effect on the home page
 */

import gsap from 'gsap';

( function() {

	const homeToggle = document.getElementById('home-switch');
	const lavaLamp = document.getElementById('LavaLampSVG');

	if(homeToggle && lavaLamp) {

		const circles = lavaLamp.querySelectorAll('circle');

		const tl = gsap.timeline();

		Array.from(circles).forEach((circle) => {

			tl.to(circle, {
				translateY: gsap.utils.random(-400, 400),
				translateX: gsap.utils.random(-400, 400),
				repeat: -1,
				duration: gsap.utils.random(10, 20),
				yoyo: true,
			}, 0).seek(4);

		});

		tl.pause();

		homeToggle.addEventListener('change', () => {

			if(tl.isActive()) {
				gsap.to(lavaLamp, {opacity: 0});
				tl.pause();
			} else {
				gsap.to(lavaLamp, {opacity: 1});
				tl.play();
			}

		});

	}

}() );
